import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';
import {RTLCol,RTLButton} from '../RTLKit';
/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import SelectFieldForLoadCity from '../formFields/SelectFieldForLoadCity';
import SelectFieldForLoadState from '../formFields/SelectFieldForLoadState';
import DynamicFieldSet from '../formFields/DynamicFieldSet';
/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: 'edit',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getAreaList();
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __permissions(){
        let data=[
            {label: 'ایجاد کاربر', value: '1', key: '1'},
            {label: 'ویرایش کاربر', value: '2', key: '2'},
            {label: 'نمایش سطح دسترسی', value: '3', key: '3'},
            {label: 'ویرایش سطح دسترسی', value: '4', key: '4'},
            {label: 'نمایش لیست کاربران', value: '5', key: '5'},
            {label: 'ویرایش پروفایل کاربران', value: '6', key: '6'},
            {label: 'نمایش جزییات کاربر', value: '7', key: '7'},
            {label: 'ایجاد شهر', value: '8', key: '8'},
            {label: 'ویرایش شهر', value: '9', key: '9'},
            {label: 'نمایش لیست شهرها', value: '10', key: '10'},
            {label: 'ایجاد استان', value: '11', key: '11'},
            {label: 'ویرایش استان', value: '12', key: '12'},
            {label: 'نمایش لیست استان', value: '13', key: '13'},
            {label: 'ایجاد خدمات تکنسین', value: '14', key: '14'},
            {label: 'ویرایش خدمات تکنسین', value: '15', key: '15'},
            {label: 'نمایش لیست خدمات تکنسین', value: '16', key: '16'},
            {label: 'ایجاد محصول', value: '17', key: '17'},
            {label: 'ویرایش محصول', value: '18', key: '18'},
            {label: 'نمایش لیست محصولات', value: '19', key: '19'},
            {label: 'ایجاد دسته بندی محصول', value: '20', key: '20'},
            {label: 'ویرایش دسته بندی محصول', value: '21', key: '21'},
            {label: 'نمایش لیست دسته های محصول', value: '22', key: '22'},
            {label: 'ایجاد سفارش و ثبت مشتری', value: '23', key: '23'},
            {label: 'مدیریت انبار', value: '25', key: '25'},
            {label: 'گزارشات انبار', value: '26', key: '26'},
            {label: 'ایجاد سند مالی', value: '27', key: '27'},
            {label: 'لیست اسناد مالی', value: '28', key: '28'},
            {label: 'لیست حساب های بانکی', value: '29', key: '29'},
            {label: 'ایجاد خدمات قابل ارايه', value: '30', key: '30'},
            {label: 'ویرایش خدمات قابل ارايه', value: '31', key: '31'},
            {label: 'بررسی و تعیین کارشناس', value: '32', key: '32'},
            {label: 'کنسل کردن سفارش', value: '33', key: '33'},
            {label: 'تسویه فاکتور', value: '34', key: '34'},
            {label: 'تسویه تکنسین', value: '35', key: '35'},
            {label: 'ایجاد تراکنش اصلاحی', value: '36', key: '36'},
            {label: 'لیست تراکنش های سیستمی', value: '37', key: '37'},
            {label: 'ثبت دستگاه پوز تکنسین', value: '38', key: '38'},
            {label: 'گزارش عملکرد تکنسین', value: '39', key: '39'},
            {label: 'گزارش کارتخوان', value: '40', key: '40'},
            {label: 'گزارش عملکرد شهرها', value: '41', key: '41'},
            {label: 'گزارش عملکرد استان', value: '42', key: '42'},
            {label: 'گزارش میانگین امتیازات', value: '43', key: '43'},
            {label: 'بررسی گارانتی', value: '45', key: '45'},
            {label: 'لیست استعلام گارانتی', value: '46', key: '46'},
            {label: 'محصولات گارانتی دار', value: '47', key: '47'},
            {label: 'ثبت فاکتور', value: '48', key: '48'},
            {label: 'درخواست استعلام', value: '49', key: '49'},
            {label: 'ثبت پرداخت نقدی', value: '50', key: '50'},
            {label: 'لغو سفارش پرداخت شده', value: '51', key: '51'},
            {label: 'تغییر وضعیت تماس', value: '52', key: '52'},
        ]  ;
        return data;
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;
        var stateList = this.__getAreaStateList();

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} سطح دسترسی</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="state_access"
                                component={SelectFieldForLoadState}
                                label="استان"
                                list={stateList}
                                mode="multiple"
                                onChangeVal={(stateId) => { _self.setState({stateId : stateId})}  }
                            />
                            <Field
                                name="permissions"
                                component={SelectField}
                                label="سطح دسترسی"
                                mode="multiple"
                                list={this.__permissions()}
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/user/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>
        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addUser',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
